import { React, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function Login() {
  const [values, setValues] = useState({
    email: '',
    password: '',
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading } = useAuth();

  // Get the page the user was trying to access
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    
    try {
      const result = await login(values);
      if (result.success) {
        navigate(from, { replace: true });
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An unexpected error occurred');
    }
  };

  return (
    <div className="min-h-screen relative bg-gray-100 overflow-hidden">
      <div className="absolute inset-0 bg-gray-100">
        {/* Zona de contenido */}
        <div className="flex flex-col flex-grow px-6 pt-10 pb-4 ml-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            ¡Welcome to Support Swiss Knife!
          </h1>
          <p className="text-md text-gray-600">
            Total control of your tickets, now in your hands.
          </p>
          <p className="text-md text-gray-600">
            Comply, report and move forward, its that simple.
          </p>
        </div>

        {/* Imagen en la parte inferior */}
        <div className="md:relative md:bottom-0 md:w-1/2 p-4">
          <img
            src="/img/clouds.png"
            alt="clouds"
            className="w-full max-w-md mx-auto"
          />
        </div>
      </div>

      <div className="relative min-h-screen flex items-center justify-end p-4 lg:p-8">
        {/* Sección derecha con login */}
        <LoginForm
          handleSubmit={handleSubmit}
          values={values}
          setValues={setValues}
          error={error}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default Login;

function LoginForm({ handleSubmit, values, setValues, error, loading }) {
  return (
    <div className="w-full max-w-md space-y-8 bg-white/90 backdrop-blur-sm shadow-xl rounded-xl border-2 border-gray-200 p-6">
      <div className="space-y-2">
        <h2 className="text-2xl lg:text-3xl font-bold text-center text-gray-800">
          Log in
        </h2>
        <p className="text-center text-gray-600">Access your account</p>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-2">
          <label htmlFor="email" className="text-sm font-medium text-gray-700">
            E-mail:
          </label>
          <input
            id="email"
            type="text"
            onChange={e => setValues({ ...values, email: e.target.value })}
            placeholder="you@example.com"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
          />
        </div>

        <div className="space-y-2">
          <label
            htmlFor="password"
            className="text-sm font-medium text-gray-700"
          >
            Password:
          </label>
          <input
            id="password"
            type="password"
            onChange={e => setValues({ ...values, password: e.target.value })}
            placeholder="***********"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
          />
        </div>

        <div className="flex items-center justify-between">
          <label className="flex items-center text-sm text-gray-900">
            <input
              type="checkbox"
              className="h-4 w-4 border-gray-300 rounded mr-2"
            />
            Remember me
          </label>
          {/* <a
            href="/register"
            className="text-sm text-red-900 hover:text-red-700"
          >
            Forgot your password?
          </a> */}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-red-900 hover:bg-red-800 disabled:bg-red-400 disabled:cursor-not-allowed text-white font-bold py-3 px-4 rounded-md transition duration-300 ease-in-out border-b-4 border-red-800 hover:border-red-700 disabled:border-red-400"
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      {/* <div className="text-center">
        <p className="text-sm text-gray-600">
          Don't have an account?{' '}
          <Link
            to="/register"
            className="font-medium text-red-900 hover:text-red-700"
          >
            Sign up
          </Link>
        </p>
      </div> */}
    </div>
  );
}
